import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { KindRootNodeStoreContext } from '../contexts/StoreContext'
import { KindRootNodeStore } from '../store/interface'

export const useKindRootNodeStore = <M extends boolean, StateSlice>(
  selector: (store: KindRootNodeStore<M>) => StateSlice
) => {
  return useContextStore<KindRootNodeStore<M>, StateSlice>(
    KindRootNodeStoreContext as any,
    selector
  )
}

export const useKindRootNodeStoreApi = <M extends boolean>() => {
  return useContextStoreApi<KindRootNodeStore<M>>(
    KindRootNodeStoreContext as any
  )
}
